<template>
    <v-navigation-drawer
        v-if="isAuthenticated"
        :value="drawer"
        fixed
        app
    >
        <v-list>
            <v-list-tile>
            <v-list-tile-title class="title">
                {{ user.name }}
            </v-list-tile-title>
            </v-list-tile>
        </v-list>
        <v-list>
            <v-list-tile>
            <v-list-tile-title class="title">
                Menú
            </v-list-tile-title>
            </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list>
            <v-list-tile
                v-for="(item, i) in theMenu"
                :key="`menu-${i}`"
                @click="goTo(item.to)"
            >
                <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile                
                @click="refreshApp"
            >
                <v-list-tile-content>
                    <v-list-tile-title>Actualizar App</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile                
                @click="closeSession"
            >
                <v-list-tile-content>
                    <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    data: () => ({
        theMenu: [
            {
                name: 'Rondas',
                to: 'home'
            }
        ]
    }),
    computed: {
        // theMenu() {
        //     const menu = [
        //         
        //     ];

        //     !!this.roundInProgress.startDate && menu.push({
        //         name: 'En progreso',
        //         to: 'roundInProgress'
        //     });

        //     return menu;
        // }
    },
    methods: {
        ...mapActions(['logout']),
        dynamicMenu() {
            if(!this.roundInProgress.startDate) return;

            this.theMenu.push({
                name: 'Ronda en Progreso',
                to: 'roundInProgress'
            });
        },
        closeSession() {
            this.logout();
            this.$router.push({ name: 'login' });
        },
        refreshApp() {
            location.reload(true);
        }
    },
    mounted() {
        this.loadRoundInProgress();
        this.dynamicMenu();
    }
}
</script>
